import { render, staticRenderFns } from "./upLoadNeed.vue?vue&type=template&id=28139396&scoped=true&"
import script from "./upLoadNeed.vue?vue&type=script&lang=js&"
export * from "./upLoadNeed.vue?vue&type=script&lang=js&"
import style0 from "./upLoadNeed.vue?vue&type=style&index=0&id=28139396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28139396",
  null
  
)

export default component.exports